export const sxHeader = {
  textOnModal: {
    color: 'primary.main',
    fontSize: 17,
    fontWeight: 700,
  },

  hiddenBar: {
    display: { xs: 'flex', lg: 'none' },
    justifyContent: 'center',
    minHeight: 50,
    width: '100%',
    p: '10px',
  },

  logo: {
    maxWidth: 200,
    height: 90,
    mr: { xs: 0, sm: 2.5 },
  },

  logoGit: {
    width: 'auto',
    height: 70,
    mr: { xs: 0, sm: 2.5 },
  },

  logoQuince: {
    height: 60,
    maxWidth: 130,
    objectFit: 'contain',
    display: 'block',
  },

  buttonHide: {
    color: '#000',
    display: { xs: 'flex', lg: 'none' },
    alignItems: 'center',
    ml: 'auto',
    alignSelf: 'center',
  },

  userContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
  },

  userName: {
    fontSize: 18,
    fontWeight: 600,
    color: '#000',
  },

  userMail: {
    fontSize: 14,
    fontWeight: 300,
    color: '#000',
  },

  itemMenu: {
    fontSize: 18,
    fontWeight: 400,
    color: '#000',
  },

  itemMenuMobile: {
    fontSize: 16,
    color: '#000',
  },

  menuLinksMobile: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    color: '#000',
    textDecoration: 'none',
    cursor: 'pointer',
  },

  hiddenGroupButtons: {
    border: '1px solid #fff',
    color: '#fff',
    fontSize: 10,
  },

  iconMobile: {
    ml: '5px',
  },

  inputStyle: {
    width: '100%',
  },

  loadingButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
  },

  header: {
    display: 'flex',
    height: 80,
  },

  logoStyle: {
    width: 155,
  },

  headerYellowRow: {
    minHeight: '8px',
    backgroundColor: 'primary.main',
    ['@media (max-width:600px)']: {
      display: 'none',
    },
  },
};
